import { UserTaxiOfficerListItem } from "../../../../../common/services/user/taxi-officer/list/user-taxi-officer-list";
import UserStatus from "../../../../../common/types/user-status";
import phoneNumberService from "../../../../../common/utils/phone-number/phone-number.service";
import TaxiOfficerListingItem from "./types/taxi-officer-listing-item";

const createMobilePhones = (
  listItem: UserTaxiOfficerListItem,
): TaxiOfficerListingItem["phoneNumbers"] => {
  const phoneNumbers: TaxiOfficerListingItem["phoneNumbers"] = [
    phoneNumberService.getLabel(listItem.phoneNumber),
  ];

  if (listItem.alternativePhoneNumber) {
    phoneNumbers.push(
      phoneNumberService.getLabel(listItem.alternativePhoneNumber),
    );
  }

  return phoneNumbers;
};

const createListingItem = (
  listItem: UserTaxiOfficerListItem,
): TaxiOfficerListingItem => {
  const phoneNumbers = createMobilePhones(listItem);

  return {
    uuid: listItem.uuid,
    firstName: listItem.firstName,
    lastName: listItem.lastName,
    username: listItem.username,
    email: listItem.email,
    phoneNumbers: phoneNumbers,
    status: !listItem.removalDate ? UserStatus.ACTIVE : UserStatus.DELETED,
  };
};

const createListingItems = (
  listItems: UserTaxiOfficerListItem[],
): TaxiOfficerListingItem[] => {
  return listItems.map(createListingItem);
};

const taxiOfficerListingItemFactory = {
  createListingItems,
};

export default taxiOfficerListingItemFactory;
